import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CalendarPicker from '../FieldEngine/FieldTypes/CalendarPicker';
//import * as moment from 'moment'
const moment = require('moment');
import LoaderComponent from '../Loader';
import CKTextEditor from "../CKTextEditor";
import { debounce } from 'lodash';
import * as CommonUtil from '../../common/util';
import { DEFAULT_TIME_FORMAT } from '../../common/constants';
import PublicApiExzeoUpload from '../PublicApiExzeoUpload';
import { postActivityReassigne, getActivityReassignRequest } from './actions';
import ConfirmationTextBox from '../ConfirmationPrompt';
import { addClass, removeClass, renderStaticImage } from '../../common/util';
import Icon from '../../icons';
import {
    getActivityAssigneeUsers,
    clearErrorValidationMessage,
} from '../../containers/SpockViewPage/actions/action';

import {    MAX_UPLOAD_FILE_SIZE,    INVALID_FILES_TO_UPLOAD,    FILE_UPLOAD_URL,} from '../../containers/WorkkardDetail/constants';
import UserImage from '../UserImage/index';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
import { useModules } from '../../utils/modules';

const assignToTypes = ['ReassignToTeamMember', 'ReassignToB2B', 'ReassignToOrganization'];
const CALENDAR_VALUE_FORMAT = 'MM/DD/YYYY, hh:mm A';
const ActivityAssigne = (props) => {
    const dispatch = useDispatch();
    const { isModuleEnabled } = useModules();
    const activityAssigneeCompData = useSelector(state => state.activityAssigneeCompData);
    const isLoading = useSelector(state => state.isLoading);
    const error = useSelector(state => state.activityAssigneeCompData.errorData);
    const errorValidationMessage = useSelector(state => state.validationError);
    const buttonLoading = useSelector(state => state.workkardDetail.buttonLoaders.activityAssignee);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;

    const [selectedSponsor, setSelectedSponsor] = React.useState(null);
    const [selectedLi, setSelectedLi] = React.useState(null);
    const [selectedRadioButton, setSelectedRadioButton] = React.useState('ReassignToTeamMember');
    const [selectedDate, setSelectedDate] = React.useState(
        (moment(activityAssigneeCompData.currentActDueDate).isValid())
            ? moment(activityAssigneeCompData.currentActDueDate, [DEFAULT_TIME_FORMAT]) : moment()
    );
    const [stateError, setStateError] = React.useState("");
    const [searchText, setSearchText] = React.useState("");
    const [privacyType, setPrivacyType] = React.useState('public');
    const [description, setDescription] = React.useState('');
    const [descriptionValidationMsg, setDescriptionValidationMsg] = React.useState('');
    const [selectedSponsorValidationMsg, setSelectedSponsorValidationMsg] = React.useState('');
    const [changeAssigneeUploadedFiles] = React.useState([]);
    const [sponsors, setSponsors] = React.useState([]);
    const [currentSponsor, setCurrentSponsor] = React.useState(null);
    const [confirmationTextMessage, setConfirmationTextMessage] = React.useState(null);
    const [activityFileJson, setActivityFileJson] = React.useState(null);
    const [dueDateValidationMsg, setDueDateValidationMsg] = React.useState("");
    const [dueDateTz, setDueDateTz] = React.useState("");

    const prevSponsorsRef = React.useRef(activityAssigneeCompData.sponsors);
    const stateRef = React.useRef({});
    stateRef.current = { searchText, selectedRadioButton, description, selectedSponsor, currentSponsor, selectedLi, dueDateTz, privacyType, activityFileJson, selectedDate };

    // componentDidMount
    React.useEffect(() => {
        if (props.actId) {
            dispatch(getActivityReassignRequest({
                actId: props.actId,
                workId: props.wkId
            }));
        }
    }, []);

    const assignToTypes = ['ReassignToTeamMember', 'ReassignToB2B', 'ReassignToOrganization'];

    React.useEffect(() => {
        if (!!errorValidationMessage.errorMessage) {
            setStateError(errorValidationMessage.errorMessage);
            return;
        }
        if (activityAssigneeCompData?.sponsors !== prevSponsorsRef.current) {
            setSponsors(activityAssigneeCompData.sponsors);
            setCurrentSponsor(activityAssigneeCompData.currentSponsor);
            const parsedDueDate = moment(activityAssigneeCompData.currentActDueDate, [DEFAULT_TIME_FORMAT]);
            setSelectedDate(parsedDueDate.isValid() ? parsedDueDate : moment());
            const tzText = activityAssigneeCompData.DueDateTz;
            const matchedTz = (sessionContext?.tzData || []).find(tz => tz.standard_time_zone === tzText || tz.mapped_time_zone === tzText || tz.display_value === tzText);
            setDueDateTz(matchedTz ? String(matchedTz.id) : "");
        }
        prevSponsorsRef.current = activityAssigneeCompData.sponsors;
        if (error) {
            setStateError(error);
        }
    }, [errorValidationMessage, activityAssigneeCompData, error]);

    const searchRef = React.useRef(debounce(() => {
        const { searchText: st, selectedRadioButton: srb, currentSponsor: curSponsor } = stateRef.current;
        const searchTxt = st.toLowerCase().trim();
        var filteredArr = [];
        if (srb === 'ReassignToTeamMember')
            filteredArr = curSponsor?.TeamMembers || [];
        else if (srb === 'ReassignToB2B')
            filteredArr = curSponsor?.B2BList || [];
        else
            filteredArr = curSponsor?.orginList || [];

        if (searchTxt) {
            filteredArr = filteredArr && filteredArr.filter((object) => {
                return object.FirstName && object.FirstName.toLowerCase().search(searchTxt) !== -1 ||
                    object.LastName && object.LastName.toLowerCase().search(searchTxt) !== -1 ||
                    object.Email && object.Email.toLowerCase().search(searchTxt) !== -1 ||
                    object.Title && object.Title.toLowerCase().search(searchTxt) !== -1 ||
                    (object.FirstName && object.LastName) && (object.FirstName + " " + object.LastName).toLowerCase().search(searchTxt) !== -1 ||
                    object.OrganizationName && object.OrganizationName.toLowerCase().search(searchTxt) !== -1 ||
                    object.OrgName && object.OrgName.toLowerCase().search(searchTxt) !== -1
            });
        }
        setSponsors(filteredArr);
    }, 200));

    const changeAssignType = (index, value) => {        
        setSelectedRadioButton(value);
        setSearchText("");
        setSponsors(value === 'ReassignToTeamMember' ? stateRef.current.currentSponsor.TeamMembers : value === 'ReassignToB2B' ? stateRef.current.currentSponsor.B2BList : stateRef.current.currentSponsor.orginList);
        setSelectedSponsor(null);
        setSelectedLi(null);
        setSelectedSponsorValidationMsg('');
        // dispatch(getActivityAssigneeUsers({ activityId: props.actId, reAssignmentType: value }));
    };

    const handleDateChange = (dateObject) => {
        setSelectedDate(dateObject);
        setDueDateValidationMsg("");
    };

    const onClose = () => {
        setConfirmationTextMessage("Do you really want to cancel the reassigning activity process? All the populated data will be lost.");
        // if(buttonLoading){ return }
        // props.onClose();
    };

    const onChangeSearchText = (e) => {
        setSearchText(e.target.value);
    };

    const selectSponsor = (data, type) => {
        let currentSelectedLi = 0;
        if (type == "ReassignToTeamMember")
            currentSelectedLi = data.UserId;
        else if (type == "ReassignToB2B")
            currentSelectedLi = data.OrganizationId;
        else
            currentSelectedLi = data.OrgId;
        setSelectedSponsor(data);
        setSelectedLi(currentSelectedLi);
        setSelectedSponsorValidationMsg('');
    };

    const chooseVisiablityType = (type) => {
        setPrivacyType(type);
    };

    const onChangeDescription = (editorData) => {
        if (editorData.replace(/[<br><p></p>&nbsp;]/g, '').trim() !== "") {
            setDescription(editorData);
            setDescriptionValidationMsg('');
        }
    };

    const reassignActivity = () => {
        // if(props.type === 'workkard'){}
        if (buttonLoading) { return; }
        const { description: desc, selectedSponsor: selSponsor, currentSponsor: curSponsor, selectedLi: selLi, dueDateTz: ddTz, privacyType: pType, activityFileJson: afj, selectedDate: selDate } = stateRef.current;        
        let trimmedDescription = desc.replace(/[<br><p></p>&nbsp;]/g, '').trim();
        let fileAttachement = [];
        const dueDate = moment(selDate).format(DEFAULT_TIME_FORMAT);
        let isValid = true;
        if (trimmedDescription.length < 1) {
            setDescriptionValidationMsg('Please add some Description.');
            isValid = false;
        }
        if (selSponsor === null) {
            setSelectedSponsorValidationMsg('Assignee is required.');
            isValid = false;
        }
        if ((curSponsor && curSponsor.ActivityOwnerOrgId == userView?.orgId.OrganizationId) && !moment(dueDate, DEFAULT_TIME_FORMAT).isValid()) {
            setDueDateValidationMsg('Due date is required.');
            isValid = false;
        }
        if (moment(dueDate, DEFAULT_TIME_FORMAT).isValid() && CommonUtil.isInValidDate(dueDate)) {
            setDueDateValidationMsg('Due date is invalid.');
            isValid = false;
        }
        if (!isValid) { return false; }
        if (afj && afj.length > 0) {
            afj.map(item => { fileAttachement.push({ "guid": item.guid, "caption": item.caption }); });
        }
        let todoDueDateISO = CommonUtil.convertDateTimeToISOString(dueDate);
        const payload = {
            workkardId: props.wkId,
            activityId: props.actId,
            due_date_iso: todoDueDateISO,
            description: desc,
            attachments: fileAttachement,
            privacy: pType == "private" ? "community" : pType,
            due_date_tz: (sessionContext?.tzData || []).find(tz => String(tz.id) === String(ddTz))?.mapped_time_zone || ''
        };
        if (stateRef.current.selectedRadioButton == "ReassignToTeamMember") {
            payload["assignee_team_member"] = selLi;
        } else {
            payload["assignee_relationship_id"] = selLi;
        }
        dispatch(postActivityReassigne(payload));
        props.onClose();
    };

    const onsaveAndUpdateFileCaption = (afj) => {
        setActivityFileJson(afj);
    };

    const handleTimezoneChange = (e) => {
        setDueDateTz(e.target.value);
    };

    if (!sponsors && stateError) {
        return (<div>{stateError}</div>);
    } else {
        if (confirmationTextMessage) {
            const modalDiv = document.querySelector(".ReactModal__Content");
            addClass(modalDiv, "confirmModal");
            addClass(modalDiv, 'cancelReassignModal');
            return (
                <div className="modalBody">
                    <ConfirmationTextBox
                        class={"act-assi-confirm-form views_actions_pop_ct modalBody"}
                        message={confirmationTextMessage}
                        onConfirmClick={() => {
                            removeClass(modalDiv, "confirmModal");
                            removeClass(modalDiv, 'cancelReassignModal');
                            props.onClose();
                        }}
                        onCancelClick={() => {
                            removeClass(modalDiv, "confirmModal");
                            removeClass(modalDiv, 'cancelReassignModal');
                            setConfirmationTextMessage(null);
                        }}
                        bothButton={true}
                        middleText={''}
                        confirmationText={"Cancel reassignment"}
                        cancelText={"Close"}
                    />
                </div>
            );
        } else {
            return (
                <div>
                    {isLoading && <LoaderComponent />}
                    {
                        (!sponsors && searchText === '')
                            ?
                            (<LoaderComponent />)
                            :
                            (
                                <React.Fragment>
                                    <div className="modalHeader">
                                        <h1>Change activity assignee</h1>
                                    </div>
                                    <div className="modalBody changeAssignee">
                                        {
                                            selectedRadioButton === 'ReassignToB2B' &&
                                            <div className="infoBoxMsg warningBoxMsg mb fastest animated fadeIn">
                                                <Icon name="info" className="icon mr" /> This reassignment of activity will lead to creation of new activity with same activity details.
                                            </div>
                                        }

                                        <div className="tabNav">
                                            <div className="tabs">
                                                <a className={selectedRadioButton == assignToTypes[0] ? "mr__1 active" : "mr__1"} onClick={() => changeAssignType(0, assignToTypes[0])}>
                                                    <label value={assignToTypes[0]} checked={selectedRadioButton === 'ReassignToTeamMember'}>Team member</label>
                                                </a>
                                                <a className={selectedRadioButton == assignToTypes[1] ? "mr__1 active" : "mr__1"} onClick={() => { (activityAssigneeCompData.currentSponsor.CanReassignActivityOutside && activityAssigneeCompData.currentSponsor.CanAssignB2B) ? changeAssignType(1, assignToTypes[1]) : null }}>
                                                    <label value={assignToTypes[1]}
                                                        checked={selectedRadioButton === 'ReassignToB2B'}
                                                        disabled={activityAssigneeCompData.currentSponsor && activityAssigneeCompData.currentSponsor.CanReassignActivityOutside == false ? true : (activityAssigneeCompData.currentSponsor && activityAssigneeCompData.currentSponsor.CanAssignB2B == true ? false : true)}>B2B</label>
                                                </a>
                                              {isModuleEnabled("activities.activity_assignment_methods.contract") &&  <a className={selectedRadioButton == assignToTypes[2] ? "mr__1 active" : "mr__1"} onClick={() => { activityAssigneeCompData.currentSponsor.CanReassignActivityOutside ? changeAssignType(2, assignToTypes[2]) : null }}>
                                                    <label value={assignToTypes[2]}
                                                        checked={selectedRadioButton === 'ReassignToOrganization'}
                                                        disabled={activityAssigneeCompData.currentSponsor && activityAssigneeCompData.currentSponsor.CanReassignActivityOutside == true ? false : true}>Active contract</label>
                                                </a>}
                                            </div>
                                        </div>

                                        <div className="searchTeamMember alignMiddle rowSpaceBetween mt mb">
                                            <label className="flexGrow mr">{selectedRadioButton === 'ReassignToTeamMember' ? "List of team members" : selectedRadioButton === 'ReassignToB2B' ? "Suggested company(s) having effective B2B" : "Suggested company(s) having effective contract on specified skillset and location"}</label>
                                            <div className="formGroup wth-4 mrNone"><input className="" type="text" placeholder={selectedRadioButton === 'ReassignToTeamMember' ? "Search by Name, Email or Title" : selectedRadioButton === 'ReassignToB2B' ? "Filter by Company name or Skillset or State or County" : "Filter by location"} onChange={(e) => onChangeSearchText(e)} value={searchText} onKeyUp={searchRef.current} /></div>
                                        </div>

                                        <div className="col-3 scrollMemberList">
                                            {
                                                searchText.length > 0 && sponsors < 1 &&
                                                <ul className="wrapFlex assigneeList">
                                                    <li className="no  result foundHere">
                                                        <div className="rowFlex userGroup">No result found</div>
                                                    </li>
                                                </ul>
                                                ||
                                                (selectedRadioButton === 'ReassignToTeamMember'
                                                    ?
                                                    (
                                                        <ul className="wrapFlex assigneeList">
                                                            {sponsors && sponsors.map((data, key) => {
                                                                return <li key={key} onClick={() => selectSponsor(data, assignToTypes[0])} className={selectedLi === data.UserId ? 'active' : ''}>
                                                                    <div className={selectedLi === data.UserId ? 'rowFlex userGroup active' : 'rowFlex userGroup'}>
                                                                        <div className="userPic userPicIcon">
                                                                           <UserImage profileUrl={data.ProfileImage} size="32" profileName={`${data.FirstName || ''} ${data.LastName || ''}`.trim()}/>
                                                                              {selectedLi === data.UserId ? <span className="badges profileChecked green"></span> : null}
                                                                        </div>
                                                                        <div className="userInfo">{data.FirstName && data.FirstName + ' ' + ((data.LastName) ? data.LastName : '')}
                                                                            <label>{data.Title}</label>
                                                                            {(data.Email) && (<span className="email" title={data.Email}>{data.Email}</span>)}
                                                                        </div>
                                                                    </div>
                                                                </li>;
                                                            })}
                                                        </ul>
                                                    )
                                                    :
                                                    selectedRadioButton === 'ReassignToB2B'
                                                        ?
                                                        (
                                                            <ul className="wrapFlex assigneeList">
                                                                {currentSponsor && currentSponsor.B2BList.length < 1 &&
                                                                    <li className="no  result foundHere"><div className="rowFlex userGroup">Unable to identify a B2B.</div></li>
                                                                }
                                                                {sponsors && sponsors.map((data, key) => {
                                                                    return <li key={key} onClick={() => selectSponsor(data, assignToTypes[1])}>
                                                                        <div className={selectedLi === data.OrganizationId ? 'rowFlex userGroup active' : 'rowFlex userGroup'}>
                                                                            <div className="userPic userPicIcon">
                                                                                <img
                                                                                    className=""
                                                                                    src={data.OrganizationImage || renderStaticImage('/images/default_org.png')}
                                                                                    onError={(e) => { e.currentTarget.src = renderStaticImage('/images/default_org.png'); }}
                                                                                />
                                                                                {selectedLi === data.OrganizationId ? <span className="badges profileChecked green"></span> : null}
                                                                            </div>
                                                                            <div className="userInfo">{data.OrganizationName}</div>
                                                                        </div>
                                                                    </li>;
                                                                })}
                                                            </ul>
                                                        )
                                                        :
                                                        (
                                                            <ul className="wrapFlex assigneeList">
                                                                {currentSponsor && currentSponsor.orginList.length < 1 &&
                                                                    <li className="no result foundHere"><div className="rowFlex userGroup">Within your organization relationships, unable to identify a contract with the required matching Skillset and/or Location.</div></li>
                                                                }
                                                                {sponsors && sponsors.map((data, key) => {
                                                                    return <li key={key} onClick={() => selectSponsor(data, assignToTypes[2])}>
                                                                        <div className={selectedLi === data.OrgId ? 'rowFlex userGroup active' : 'rowFlex userGroup'}>
                                                                            <div className="userPic userPicIcon">
                                                                                <img className="" src={data.OrgProfileImageUrl && data.OrgProfileImageUrl} />
                                                                                {selectedLi === data.OrgId ? <span className="badges profileChecked green"></span> : null}
                                                                            </div>
                                                                            <div className="userInfo">{data.OrgName}</div>
                                                                        </div>
                                                                    </li>;
                                                                })}
                                                            </ul>
                                                        )
                                                )
                                            }
                                        </div>
                                        <span className="errorSelfMsg mb mt">{selectedSponsorValidationMsg}</span>

                                        <div className="formGroup borderTop assigneeDescription">
                                            <div className="colFlex mt">
                                                <div className="rowFlex alignMiddle">
                                                    <label className="">Description <sup>*</sup></label>
                                                    <div className="rowFlex mb__8  alignRight alignMiddle">
                                                        <label className="mrNone">Choose Visibility</label>
                                                        <div className="inputSegment flex alignRight ml">
                                                            <a data-tooltip={'Choosing Internal will make this note visible only within your organization.'} className={privacyType === "private" ? "btn active btnSegment" : 'btn btnSegment'} type="button" onClick={() => chooseVisiablityType('private')}>Internal</a>
                                                            <a data-tooltip={'Choosing Public will make this note visible to all participating organization(s).'} className={privacyType === "public" ? "btn active btnSegment tooltip-in" : "btn btnSegment"} type="button" onClick={() => chooseVisiablityType('public')}>Public</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="editorContainer">
                                                    {/* <TextEditor editorData={description} placeholderText="Enter description " onChange={(editorContent) => onChangeDescription(editorContent)} /> */}
                                                    <CKTextEditor editorData={description} placeholderText="Enter description " onChange={(editorContent) => onChangeDescription(editorContent)} />
                                                </div>
                                                {/* <textarea placeholder="Enter description " onChange={(e) => onChangeDescription(e)} /> */}
                                                {descriptionValidationMsg.length > 0 &&
                                                    <span className="errorSelfMsg mt">{descriptionValidationMsg}</span>
                                                }
                                            </div>
                                        </div>

                                        {currentSponsor && currentSponsor.ActivityOwnerOrgId == userView?.orgId &&
                                            <div className="formGroup colFlex assigneeDueDate">
                                                <label className="">Activity due date <sup>*</sup></label>
                                                <div className="dueActive">
                                                    <div className="wth-4">
                                                        <CalendarPicker
                                                            value={selectedDate && moment(selectedDate).isValid() ? moment(selectedDate).format(CALENDAR_VALUE_FORMAT) : ''}
                                                            onChange={(iso) => handleDateChange(iso ? moment(iso) : null)}
                                                            minDate={moment().format('MM/DD/YYYY')}
                                                            showTime
                                                            placeholder="Activity Due Date"
                                                        />
                                                    </div>
                                                    <select className="ml wth-3" value={dueDateTz} onChange={handleTimezoneChange}>
                                                        <option value="">Select timezone</option>
                                                        {
                                                            (sessionContext?.tzData || []).map(item => {
                                                                return <option key={item.id} value={String(item.id)}>{item.display_value}</option>;
                                                            })
                                                        }
                                                    </select>
                                                    <small className="ml alignMiddle wth-5">Specify the new due date of the activity.</small>
                                                </div>
                                                {dueDateValidationMsg.length > 0 &&
                                                    <span className="errorSelfMsg mt">{dueDateValidationMsg}</span>
                                                }
                                            </div>
                                        }
                                        <div className="assigneeAttachment formGroup mt__1 mr__b__0 ">
                                            {/* <a>Attach file</a> */}
                                            <PublicApiExzeoUpload
                                                url={FILE_UPLOAD_URL}
                                                maxSize={MAX_UPLOAD_FILE_SIZE}
                                                inValidFiles={INVALID_FILES_TO_UPLOAD}
                                                multiple={true}
                                                uploadedData={changeAssigneeUploadedFiles}
                                                saveAndUpdateFileCaption={onsaveAndUpdateFileCaption}
                                            />
                                        </div>

                                        {/* {privacyType === '_public'
                                        &&
                                        <label className="textCenter mt">* Choosing Public will make this note visible to all participating organization(s).</label>
                                        ||
                                        <label className="textCenter mt">* Choosing Internal will make this note visible only within your organization.</label>
                                        } */}
                                    </div>

                                    <div className="modalFooter">
                                        <div className="rowFlex alignRight">
                                            <button className="btn buttonGradient" onClick={reassignActivity}>
                                                {buttonLoading && <LoaderComponent />}
                                                <span style={{ visibility: buttonLoading ? "hidden" : "" }}>Reassign</span>
                                            </button>
                                            <button className="btn link" onClick={onClose}>Cancel</button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                    }
                </div>
            );
        }
    }
};

export default ActivityAssigne;